import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./about-us.css";
import {
  AboutHeroSection,
  AboutMarketplaceSection,
  AboutValuesSection,
  AboutComparisonSection,
  AboutLicenseSection,
  AboutCtaSection,
} from "./AboutSections";

const AboutCompany = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>About AGCX | Licensed Crypto Exchange Company in the UAE</title>
        <meta
          name="description"
          content="Learn about AGCX, a UAE-based, CMA-licensed digital asset exchange serving retail and institutional clients across the UAE and global markets."
        />
        <meta name="keywords" content="about AGCX, licensed crypto exchange UAE, AGCX company"></meta>

        <link rel="canonical" href="https://arabglobal.ae/about_us/company" />
      </Helmet>

      <div className="agc_about_page_wrapper">
        <AboutHeroSection />
        <AboutMarketplaceSection />
        <AboutValuesSection />
        <AboutComparisonSection />
        <AboutLicenseSection />
        <AboutCtaSection />
      </div>
    </>
  );
};

export default AboutCompany;
